<template>
    <div class="black-bg" v-if="modalData == true">
        <div class="white-bg">
            <img :src="oneroom[clickData].image" style="width:100%">
            <h4>{{ oneroom[clickData].title }}</h4>
            <p>{{ oneroom[clickData].content }}</p>
            <p>{{ oneroom[clickData].price * month }} 원</p>
            <p><input v-model="month"></p>
        </div>
        <button @click="$emit('closeModal')">닫기</button>
    </div>
</template>

<script>

export default {
    name : 'Modal',
    props :  {
        oneroom : Array,
        clickData : Number,
        modalData : Boolean,
        close : Function
    },
    watch : {
        month(value){
            if (isNaN(value) == true ) {
                alert("문자입력ㄴㄴ");
                this.month = 1;
            }
        }
    },
    data(){
        return {
            month : 0
        }
    }
}
</script>

<style scoped>

</style>